<template lang="pug">
div
  app-modal(
    v-if="showModal"
    :closeOutside="false",
    :titulo="isEdit ? 'Edição Sócio' : 'Adicionar Sócio'",
    :width="1000",
    @closeModal="cancelar"
  )
    template(slot="body")
      .modal-body-socio
        validation-observer(ref='observerSocio')
          app-pessoa-socio(:pessoa="socio")
          app-documentos(
            :maxSize='25',
            :valid-extensions="['pdf','rar', 'zip']",
            :documentos="socio.documentos"
            :tiposDocumentos="documentos"
            :tiposDocumentosObrigatorios="documentosObrigatoriosControle"
            aba="Interessado"
            :observer="$refs.observerSocio"
          )
    template(slot="footer")
      div.buttons
        el-button(
          type="default",
          @click="cancelar"
        ) Cancelar
        el-button(
          type="primary",
          @click="adicionarSocio"
        ) {{ isEdit ? 'Atualizar' : 'Adicionar' }}

  app-divider(label="Listagem de Sócios")
    template(slot="body")
      .btn-adicionar
        el-button(type='primary', size="small" @click="openModalAdicionar")
          i.fal.fa-plus
          | &nbsp Adicionar
  el-row
    el-table(
      :data='socios'
    )
      div(slot='empty')
        span Não há registros.
      el-table-column(
        prop="pessoaFisica.cpf"
        label='CPF'
        align="left",
      )
      el-table-column(
        prop="pessoaFisica.nome"
        label='Nome'
      )
      el-table-column(
        label='Ações',
        align="center",
        width="100"
      )
        template(slot-scope='scope')
          el-dropdown(trigger="click", size="small")
            el-button(type='primary', size="mini")
              | Ações
              i.el-icon-arrow-down.el-icon--right
            el-dropdown-menu(slot='dropdown')
              div
                el-dropdown-item
                  .flex(@click="editarSocio(scope.row)")
                   i.fal.fa-pencil-alt
                    | &nbsp Editar
              div
                el-dropdown-item
                  .flex(@click="removeSocio(scope.row.pessoaFisica.cpf)")
                    i.fa.fa-times
                    | &nbsp Remover
</template>

<script>
import AppDivider from '@/components/AppDivider'
import AppActionButton from '@/components/AppActionButton'
import AppModal from '@/components/AppModal'
import AppDocumentos from './AppDocumentos'
import AppPessoaSocio from './AppPessoaSocio'
import emptyPessoa from '../../cadastros/para/empty/emptyPessoa'
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

const emptySocio = {
  ...emptyPessoa,
  pessoaFisica: {
    ...emptyPessoa.pessoaFisica
  },
  documentos: []
}

export default {
  mixins: [
    AppNotificacao
  ],

  components: {
    AppDivider,
    AppActionButton,
    AppModal,
    AppDocumentos,
    AppPessoaSocio
  },

  async created () {
    this.documentos = await this.findDocumentos('socioInteressado')
    this.documentosObrigatorios = await this.findDocumentos('obrigatorios/socioInteressado')
    this.documentosObrigatoriosControle = this.documentosObrigatorios
  },

  data () {
    return {
      socio: _.cloneDeep(emptySocio),
      documentos: [],
      documentosObrigatorios: [],
      documentosObrigatoriosControle: [],
      showModal: false,
      isEdit: false,
      isMaranhao: process.env.ESTADO === 'ma'
    }
  },

  props: {
    socios: {
      type: Array,
      required: true
    },

    aba: {
      type: String,
      default: 'Interessado'
    },

    required: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    ...mapActions({
      findDocumentos: 'tipoDocumento/findTiposDocumento'
    }),

    openModalAdicionar () {
      this.socio = _.cloneDeep(emptySocio)
      this.showModal = true
    },

    async adicionarSocio () {
      const valid = await this.$refs.observerSocio.validate()

      if (valid) {
        let socio = _.find(this.socios, item => item.pessoaFisica.cpf === this.socio.pessoaFisica.cpf)

        if (socio && !this.isEdit) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            'Esse CPF já se encontra na lista de sócios.'
          )

          return
        }

        if (this.isEdit) {
          socio = this.socio
          this.isEdit = false
        } else {
          this.socio.id = uuidv4()
          this.socios.push(this.socio)
        }

        this.showModal = false
        return
      }

      this.showNotificacao(
        this.$messages.TIPO_WARNING,
        this.$messages.TITULO_WARNING,
        this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
      )
    },

    cancelar () {
      this.showModal = false
      this.isEdit = false
      this.$refs.observerSocio.reset()
    },

    removeSocio (cpf) {
      this.confirmBox('Tem certeza que deseja remover?', this.$messages.TITULO_WARNING,
        () => {
          const index = _.findIndex(this.socios, item => item.pessoaFisica.cpf === cpf)
          this.socios.splice(index, 1)
        },
        () => {
        }, 'Sim', 'Não')
    },

    editarSocio (socio) {
      this.isEdit = true
      this.socio = socio
      this.showModal = true
    }
  },
  watch: {
    'socio.documentos': {
      async handler (val) {
        if (val && this.isMaranhao) {
          const codigosJaAnexados = []
          val.forEach(v => {
            if (v?.tipoDocumento?.codigo === 'IDENTIFICACAO_PESSOAL_SOCIO') {
              codigosJaAnexados.push('CPF_SOCIO')
              codigosJaAnexados.push('IDENTIFICACAO_SOCIO')
            }
            codigosJaAnexados.push(v?.tipoDocumento?.codigo)
          })
          this.documentosObrigatoriosControle = this.documentosObrigatorios.filter(documento => (!codigosJaAnexados.includes(documento.tipo)))
        }
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.btn-adicionar {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;
}

.modal-body-socio {
  padding: 0 20px;
}

.buttons {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/cadastro/AppSocio.vue